import { useParams } from "react-router-dom";

export const usePopupImportPageParams = () => {
  const { siteSlug = "" } = useParams();

  return { siteSlug };
};
